import _extends from "@babel/runtime/helpers/esm/extends";
import { ELanguage } from '../common';
import { fieldsIBaseModel } from './base';
export let EPatientMessageTemplateChannel;
(function (EPatientMessageTemplateChannel) {
  EPatientMessageTemplateChannel["Sms"] = "sms";
  EPatientMessageTemplateChannel["Email"] = "email";
  EPatientMessageTemplateChannel["Voice"] = "voice";
  EPatientMessageTemplateChannel["Whatsapp"] = "whatsapp";
})(EPatientMessageTemplateChannel || (EPatientMessageTemplateChannel = {}));
export let EPatientMessageTemplateType;
(function (EPatientMessageTemplateType) {
  EPatientMessageTemplateType["Chat"] = "chat";
  EPatientMessageTemplateType["Broadcast"] = "broadcast";
})(EPatientMessageTemplateType || (EPatientMessageTemplateType = {}));
export const fieldsPatientMessageTemplate = _extends({}, fieldsIBaseModel, {
  autoCloseChat: {
    type: 'Boolean'
  },
  channel: {
    type: 'Option',
    values: EPatientMessageTemplateChannel
  },
  language: {
    type: 'Option',
    values: ELanguage
  },
  message: {
    type: 'Text'
  },
  name: {
    type: 'Text'
  },
  type: {
    type: 'Option',
    values: EPatientMessageTemplateType
  }
});